import { createFilteredSink } from "../policy";
import { SinkPolicy } from "../types";

const CONSOLE_METHOD = {
    info: "log",
    warn: "warn",
    error: "error",
} as const;

export const createConsoleSink = (policy: Partial<SinkPolicy> = {}) =>
    createFilteredSink(
        "console",
        (entry) => {
            const args = entry.error
                ? [...entry.args, entry.error]
                : entry.args;

            const head = entry.categories.length
                ? `[${entry.categories.join(", ")}] ${entry.message}`
                : entry.message;

            // eslint-disable-next-line no-console
            console[CONSOLE_METHOD[entry.level]](head.trimEnd(), ...args);
        },
        policy,
    );
